module.exports = __webpack_public_path__ + "assets/65a7331d8b35851a0255b7d945bee13c.ttf";